export default __webpack_public_path__ + "static/media/Nitroxgallery_6.9130a144.JPG";